<template>
    <router-link :to="{ name: 'partner-timeslot.show', query: {
            doctorId: appointment.doctorId,
            dateTime: appointment.dateTime,
            medicalPractice: appointment.medicalPractice,
            latitude: appointment.officeLatitude,
            longitude: appointment.officeLongitude,
        } }" tag="div" class="group shadow mb-6 cursor-pointer text-grey-darkest leading-normal">
        <div class="flex items-top p-3 md:p-6 bg-white rounded-t">
            <partner-avatar :external-url="appointment.doctorAvatar" class="mr-2 w-10 h-10 md:w-12 md:h-12"></partner-avatar>
            <div class="ml-4">
                <div class="flex md:mb-1">
                    <span class="icon mr-2 md:text-lg text-grey-darkest"><i class="mdi mdi-calendar-check"></i></span>
                    <span class="text-grey-darkest font-semibold text-sm md:text-base">{{ appointment.dateTime | momentFormatTimestamp($t('date_selector_format') + ' [' + $t('at') + '] ' + $t('time_format')) }}</span>
                </div>
                <div class="flex md:mb-1">
                    <span class="icon mr-2 text-lg text-red-light"><i class="mdi mdi-map-marker"></i></span>
                    <span class="text-sm md:text-base">
                        {{ appointment.officeZipCode }} {{ appointment.officeLocality }}<br />
                        {{ appointment.officeStreetName }}
                    </span>
                </div>
                <div class="flex">
                    <span class="icon mr-2 text-lg text-blue-light"><i class="mdi mdi-account"></i></span>
                    <span class="text-sm md:text-base">{{ appointment.doctorFirstName + ' ' + appointment.doctorLastName }}</span>
                </div>
            </div>
        </div>
        <div class="transition flex rounded-b bg-teal group-hover:bg-teal-dark text-white py-1 justify-center">
            <span class="uppercase tracking-wide font-semibold text-sm" v-text="$t('Appointment_confirmed')"></span>
        </div>
    </router-link>
</template>
<script>
    import PartnerAvatar from '@/components/PartnerAvatar.vue'

    export default {
        name: 'partner-appointment-list-item',

        props: ['appointment'],

        components: { PartnerAvatar }
    }
</script>



// WEBPACK FOOTER //
// src/components/Patient/PartnerAppointmentListItem.vue